module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-345.94a3ea8.woff2";